var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.currentRow.id ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "from",
    attrs: {
      model: _vm.from,
      rules: _vm.roleRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "appUrl",
      label: _vm.$t("应用图标")
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      headers: _vm.headers,
      data: {
        module: "application"
      }
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.imageUrl ? _c("img", {
    staticStyle: {
      width: "104px",
      height: "104px"
    },
    attrs: {
      src: _vm.imageUrl,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("上传")) + " ")])], 1)])], 1), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("应用名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.from.name,
      callback: function ($$v) {
        _vm.$set(_vm.from, "name", $$v);
      },
      expression: "from.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应用类型"),
      prop: "type"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.from.type,
      callback: function ($$v) {
        _vm.$set(_vm.from, "type", $$v);
      },
      expression: "from.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v("app")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v("h5")]), _c("a-radio", {
    attrs: {
      value: 3
    }
  }, [_vm._v("pc")]), _c("a-radio", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("小程序")))])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "appid",
      label: "appId"
    }
  }, [_c("a-input", {
    model: {
      value: _vm.from.appid,
      callback: function ($$v) {
        _vm.$set(_vm.from, "appid", $$v);
      },
      expression: "from.appid"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "customerId",
      label: _vm.$t("牌照所属")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("牌照所属"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.from.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.from, "customerId", $$v);
      },
      expression: "from.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "introduce",
      label: _vm.$t("应用介绍")
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 4
    },
    model: {
      value: _vm.from.introduce,
      callback: function ($$v) {
        _vm.$set(_vm.from, "introduce", $$v);
      },
      expression: "from.introduce"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };